module.exports = __webpack_public_path__ + "img/second-day-2.c3c10e4f.webp";